import { API } from '@apis/endPoints';
import { axiosService, checkError } from '@services';
import dayjs from 'dayjs';

export default async function getEnergyBalanceDay(plant_id, dateToday=dayjs()) {
  if(!plant_id) {
    throw new Error('Plant ID is required');
  }

  const res = await axiosService({
    method: 'post',
    data: {
      path: `/measurements/sets/EnergyBalance/Day?Date=${dateToday.format('YYYY-MM-DD')}&WithTotal=true`,
      plant_id: plant_id,
    },
    apiPath: `${API.PLANT_MANAGEMENT}`,
  });

  if (res?.codeHTTP === 200) {
    return res.data.result;
  } else {
    return checkError(res, getEnergyBalanceDay, plant_id, dateToday);
  }
}

// const getEnergyBalanceDay = async () => {
//   const res = await axiosService({
//     method: 'post',
//     params: {
//       path: `/measurements/sets/EnergyBalance/Day?Date=${dateToday.format('YYYY-MM-DD')}&WithTotal=true`,
//       // eslint-disable-next-line camelcase
//       plant_id: id,
//     },
//     apiPath: `${API.PLANT_MANAGEMENT}`,
//   });
//   if (res?.codeHTTP === 200) {
//     setPvGenerationDay(res.data.result.total.pvGeneration);
//     setGraph(res.data.result.set);
//   } else {
//     await checkError(res, apiEnergyBalanceDay);
//   }
// };
